export default {
  methods: {
    playSuccess() { new Audio(process.env.VUE_APP_ASSETS_URL + "/worf.mp3").play() },
    playFail() { new Audio(process.env.VUE_APP_ASSETS_URL + "/wrong-answer.mp3").play() }
  }
}
